export class MinesBackend {
  public static EventTypes = {
    returnMultiplier: "minesreturnmultiplier",
    gameEnded: "minesgameover",
    bombExploded: "minesbombexploded",
    StartGameData: "minesstartgamedata"
  };
}
